import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=b28aca82&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=ts"
export * from "./Avatar.vue?vue&type=script&lang=ts"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=b28aca82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28aca82",
  null
  
)

export default component.exports